var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
export default function SchedulerHead(_a) {
    var selectedDate = _a.selectedDate, setSelectedDate = _a.setSelectedDate, setSelectedSlot = _a.setSelectedSlot, times = _a.times;
    return (_jsx("div", __assign({ className: "mp-scheduler-dates" }, { children: times.map(function (date) { return (_jsxs("button", __assign({ id: "mp-scheduler-date-".concat(date.formatted.day), className: classnames("mp-scheduler-date", {
                "is-disabled": date.disabled,
                "is-selected": (date.date && date.date.toDateString()) ===
                    (selectedDate.date && selectedDate.date.toDateString()),
            }), disabled: date.disabled, onClick: function () {
                setSelectedDate(date);
                setSelectedSlot({});
            }, type: "button" }, { children: [_jsx("div", __assign({ className: "mp-date-weekday" }, { children: date.formatted.weekday })), _jsx("div", __assign({ className: "mp-date-day" }, { children: date.formatted.day }))] }), date.date.toString())); }) })));
}
